// extracted by mini-css-extract-plugin
export default {"mainContainer":"Socials_mainContainer__3RU4p","btn":"Socials_btn__5DQgH","pulse":"Socials_pulse__TsaR4"};